import { UploadFile, FileUploaderLabels } from './types';
import { FileItem } from './FileItem';

type FileListProps = {
  files: UploadFile[];
  onRemove: (key: string) => void;
  onRetry: (key: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
  labels?: FileUploaderLabels;
};

export const FileList = ({
  files,
  onRemove,
  onRetry,
  disabled,
  readOnly,
  labels,
}: FileListProps) => {
  if (files.length === 0) return null;

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}
      role="list"
      aria-label={labels?.listAriaLabel ?? 'Uploaded files'}
    >
      {files.map((file) => (
        <div key={file._key} role="listitem">
          <FileItem
            file={file}
            onRemove={onRemove}
            onRetry={onRetry}
            disabled={disabled}
            readOnly={readOnly}
            labels={labels}
          />
        </div>
      ))}
    </div>
  );
};
